import axios from 'axios';
import Qs from 'qs';
import baseUrl from '../config'; // 这里设置了一个文件作为所有请求的基础ip地址
import store from '@/store/index.js';

// 添加请求拦截器
var CancelToken = axios.CancelToken;
var source = CancelToken.source();
axios.defaults.baseURL=(process.env.NODE_ENV === 'development') ?'/api':baseUrl.DOMAIN_NAME.URL_CNODEJS;
// axios.defaults.baseURL=(process.env.NODE_ENV === 'development') ?'/testApi':baseUrl.DOMAIN_NAME.URL_CNODEJS;
axios.interceptors.request.use(function (config) {
    if (store.state.token) {
        config.headers.Authorization = 'Bearer ' + store.state.token;
    }
    return config;
}, function (error) {
    // 预处理请求错误（error）
    return Promise.reject(error);
});

// 添加响应拦截器
axios.interceptors.response.use(function (response) {
    // 预处理响应数据（response）如果数据当中有不要的部分，就截留
    // console.log(response)
    return response.data;
}, function (error) {
    // 预处理响应错误（error)
    // alert(error);
    return Promise.reject(error);
});

export default function (url, {
    // 不传时，默认参数
    method = 'get',
    timeout = 180000,
    data = {},
    params = {},
    cancelToken = '',
    headers = {'Content-Type': 'application/json'},  // application/x-www-form-urlencoded;charset=UTF-8;
    responseType = 'json'
}) {
    const config = {
        method: method,
        timeout: timeout,
        url: url, // 如果URL是完整的，包含域名，则下方的域名不会被拼接
        // baseURL: baseUrl.URL_CNODEJS, // 域名，在最外层的config.js当中可以修改，请求目标服务器域名配置，结合我们自己的项目，在项目放置到服务器上时，就是将域名替换成192.168.1.3
        data: data,
        params: params,
        canelToken: cancelToken, // 关闭请求
        headers: headers,
        responseType: responseType
    };
    return axios(config);
}
